<div class="container-fluid organization-container overflow-hidden">
	<div class="row" *ngIf="!viewMode">

		<div class="go-back-container">
			<div class="go-back">
				<a href="javascript:void(0)" (click)="returnToProductList()">
					<i class="fa fa-arrow-left"></i>
					<span>Products List</span>
				</a>
			</div>
			<div class="go-back-container__title">{{ title }}</div>
		</div>

		<div class="buttons">
			<button class="btn btn-sm cv-btn-light" [disabled]="saving" (click)="onCancel()">
				CANCEL
			</button>
			<button [disabled]="saving || !isFormValid()" class="btn btn-sm cv-btn-blue" (click)="onSave()">
				<div *ngIf="saving" class="loading-wrapper">
					<i class="fas fa-spinner"></i>
				</div>
				SAVE
			</button>
		</div>
	</div>
	<div class="row">
		<div class="col info-content basic-info">
		<h4 class="mt-4">BASIC INFO</h4>
		<p class="mb-4 info-test">
			Once you select the Origin (located below) you will be able to enable or
			disable the integrations located in the right panel to add relevant
			information about this order. Fields marked with red are required.
		</p>
		<cv-dropdown
			[required]="true"
			[label]="'Origin (Source of the incoming order)'"
			[placeholder]="'Select an Origin'"
			[selectedValue]="originSelected"
			[options]="originList"
			[optionText]="'name'"
			[disabled]="isEdit"
			(valuesChange)="onOriginSelected($event)"
		>
		</cv-dropdown>
		<hr class="mb-4 mt-5" />
		<cv-input
			(controlKeyup)="productData.title = $event.value.trim()"
			[value]="productData.title"
			[label]="'Title'"
			[type]="'text'"
			[name]="'name'"
			[minlength]="1"
			[required]="true"
			[placeholder]="'Title Product'"
			[disabled]="viewMode"
		></cv-input>
		<hr class="mb-4 mt-5" />
		<cv-dropdown
			[required]="false"
			[label]="'Line of Business'"
			[placeholder]="'Select a line of Business'"
			[selectedValue]="lineSelected"
			[options]="lineBusinessList"
			[optionText]="'name'"
			(valuesChange)="onLineBusinessSelected($event)"
		>
		</cv-dropdown>
		<div class="product-check-container mb-1 mt-5">
			<cv-switch
				[class]="'cv-switch-blue'"
				[checked]="productData.active"
				[size]="'sm'"
				(valueChange)="activateProduct($event)"
				[disabled]="viewMode"
			></cv-switch>
			<span class="info-test">Show Product status as Active</span>
		</div>
		<div class="product-check-container mb-4">
			<cv-switch
				[class]="'cv-switch-blue'"
				[checked]="productData.isOrganizationLevel"
				[size]="'sm'"
				(valueChange)="activateBoolField($event, 'isOrganizationLevel')"
				[disabled]="viewMode"
			></cv-switch>
			<span class="info-test">Is it at Organization Level Product?</span>
		</div>

		<cv-input
			(controlKeyup)="productData.description = $event.value"
			[value]="productData.description"
			[label]="'Description'"
			[type]="'textarea'"
			[name]="'Description'"
			[rows]="8"
			[minlength]="1"
			[required]="true"
			[disabled]="viewMode"
		>
		</cv-input>
		</div>
		<div class="col info-content integration-info" [ngClass]="{'readOnly': viewMode}">
		<div class="product-check-container border-b" *ngIf="canSetNexsys">
			<h5>INTEGRATIONS:</h5>
			<cv-switch
				*ngIf="canSetNexsys"
				[class]="'cv-switch-blue'"
				[checked]="productData.nexsys.enabled"
				[size]="'sm'"
				(valueChange)="activateSection('nexsys', $event)"
				[disabled]="viewMode"
			>
			</cv-switch>
			<span *ngIf="canSetNexsys"> Nexsys </span>
			<cv-switch
				*ngIf="canSetNexsys"
				[class]="'cv-switch-blue'"
				[checked]="productData.valutrust.enabled"
				[size]="'sm'"
				(valueChange)="activateSection('valutrust', $event)"
				[disabled]="viewMode"
			>
			</cv-switch>
			<span *ngIf="canSetNexsys"> ValuTrust </span>
			<cv-switch
				*ngIf="canSetNexsys"
				[class]="'cv-switch-blue'"
				[checked]="productData.xpanse.enabled"
				[size]="'sm'"
				(valueChange)="activateSection('xpanse', $event)"
				[disabled]="viewMode"
			>
			</cv-switch>
			<span *ngIf="canSetNexsys"> Xpanse </span>
			<cv-switch
				*ngIf="canSetNexsys"
				[class]="'cv-switch-blue'"
				[checked]="productData.fnc.enabled"
				[size]="'sm'"
				(valueChange)="activateSection('fnc', $event)"
				[disabled]="viewMode"
			>
			</cv-switch>
			<span *ngIf="canSetNexsys"> FNC </span>
			<cv-switch
				*ngIf="canSetNexsys"
				[class]="'cv-switch-blue'"
				[checked]="productData.integration.enabled"
				[size]="'sm'"
				(valueChange)="activateSection('integration', $event)"
				[disabled]="viewMode"
			>
			</cv-switch>
			<span *ngIf="canSetNexsys">Integration</span>
		</div>
		<div
			class="product-check-container border-b"
			*ngIf="canSetAcuity || canSetAppScope"
		>
			<h5>TRACKING SYSTEMS:</h5>
			<cv-switch
				*ngIf="canSetAppScope"
				[class]="'cv-switch-blue'"
				[checked]="productData.appScope.enabled"
				[size]="'sm'"
				(valueChange)="activateAppScope($event)"
				[disabled]="viewMode"
			>
			</cv-switch>
			<span *ngIf="canSetAppScope"> AppScope</span>
			<cv-switch
				*ngIf="canSetAcuity"
				[class]="'cv-switch-blue'"
				[checked]="productData.acuity.enabled"
				[size]="'sm'"
				(valueChange)="activateAcuity($event)"
				[disabled]="viewMode"
			>
			</cv-switch>
			<span *ngIf="canSetAcuity"> Acuity</span>
		</div>
		<div
			class="integration-form form-type-{{ productData.origin.toLowerCase() }}"
			[ngClass]="{
			'remove-padding':
				productData.origin === 'Class' &&
				!classValuationIntegration.isEnabled
			}"
			*ngIf="hasOrigin; else emptySelection"
		>
			<fieldset *ngIf="canSetNexsys">
				<div
					class="select-generic-integration"
					*ngIf="productData.integration.enabled"
				>
					<cv-dropdown
						*ngIf="productData.integration.enabled"
						[required]="true"
						[label]="'Integration'"
						[placeholder]="'Select an Integration'"
						[selectedValue]="genericIntegrationSelected"
						[options]="genericIntegrationList"
						[optionText]="'name'"
						[disabled]="viewMode"
						(valuesChange)="onGenericIntegrationSelected($event)"
					>
					</cv-dropdown>
				</div>

				<div *ngIf="classValuationIntegration.isEnabled">

					<h6>{{ classValuationIntegration.integrationText }} Integration</h6>

					<p class="mb-4 info-test">
						{{ classValuationIntegration.integrationText }} Integration(Select
						the product that the incoming order need to match)
					</p>

					<div
						class="product-check-container"
					>
						<cv-switch
							[class]="'cv-switch-blue'"
							[checked]="classValuationIntegration.isDefaultProduct"
							[size]="'sm'"
							(valueChange)="nexsysIsDefaultProduct($event)"
							[disabled]="viewMode"
						>
						</cv-switch>
						<span>Default Product Configuration</span>
					</div>
					<cv-multiselect-search
						[required]="!classValuationIntegration.isDefaultProduct"
						[label]="'Product Name'"
						[placeholder]="'Select a Nexsys Attribute'"
						[options]="classValuationIntegration.productList"
						[values]="classValuationIntegration.optionSelected"
						[optionText]="'title'"
						[optionValue]="'id'"
						[singleSelectMode]="true"
						(valuesChange)="onNexsysProductSelected($event)"
						*ngIf="
						!classValuationIntegration.isDefaultProduct
						"
						[disabled]="viewMode"
					>
					</cv-multiselect-search>
					<div
						class="row"
						*ngIf="
						!classValuationIntegration.isDefaultProduct
						"
					>
						<div class="col-sm-12 cv-input">
						<div class="product-check-container">
							<cv-switch
								[class]="'cv-switch-blue'"
								[checked]="classValuationIntegration.isFhaProduct"
								[size]="'sm'"
								(valueChange)="isFhaProcductNexsys($event)"
								[disabled]="viewMode"
							>
							</cv-switch>
							<span> Is a FHA Product</span>
							<cv-switch
								[class]="'cv-switch-blue'"
								[checked]="classValuationIntegration.isOrderIncomeStatement"
								[size]="'sm'"
								(valueChange)="isOrderIncomeStatement($event)"
								*ngIf="productData.valutrust.enabled || productData.xpanse.enabled || productData.integration.enabled"
								[disabled]="viewMode"
							>
							</cv-switch>
							<span *ngIf="productData.valutrust.enabled || productData.xpanse.enabled || productData.integration.enabled">
							Is Order Income Statement</span
							>
							<cv-switch
								[class]="'cv-switch-blue'"
								[checked]="classValuationIntegration.isOrderRentSchedule"
								[size]="'sm'"
								(valueChange)="isOrderRentSchedule($event)"
								*ngIf="productData.valutrust.enabled || productData.xpanse.enabled || productData.integration.enabled"
								[disabled]="viewMode"
							>
							</cv-switch>
							<span *ngIf="productData.valutrust.enabled || productData.xpanse.enabled || productData.integration.enabled">
							Is Order Rent Schedule</span
							>
						</div>
						<cv-input
							(controlKeyup)="
							classValuationIntegration.defaultFhaNumber =
								$event.value.trim()
							"
							[value]="classValuationIntegration.defaultFhaNumber"
							[type]="'text'"
							[name]="'name'"
							[minlength]="1"
							[disabled]="!classValuationIntegration.isFhaProduct || viewMode"
							[placeholder]="'Default FHA Number '"
						></cv-input>
						</div>
					</div>
					<div
						class="row"
						*ngIf="
						!classValuationIntegration.isDefaultProduct &&
						productData.nexsys.enabled
						"
					>
						<div class="col-sm-12 cv-input orders-attribute">
							<cv-multiselect-search
								[label]="'Include order attribute'"
								[placeholder]="'Select a Nexsys Attribute'"
								[options]="nexsysAttributesList"
								[values]="nexsysAttributeSelected"
								[optionText]="'title'"
								[optionValue]="'id'"
								(valuesChange)="onNexsysAttributeSelected($event)"
								[disabled]="viewMode"
							>
							</cv-multiselect-search>
						</div>
					</div>
				</div>
			</fieldset>
			<fieldset *ngIf="canSetAppScope" class="border-b">
			<h6>AppScope Tracker</h6>
			<p class="mb-4 info-test">{{ enableAppScopeMsg }}</p>
			<cv-multiselect-search
				[required]="productData.appScope.enabled"
				[label]="'Job Name'"
				[placeholder]="'Select an Job Name'"
				[disabled]="!productData.appScope.enabled"
				[options]="appScopeProductList"
				[values]="appScopeSelected"
				[optionText]="'title'"
				[optionValue]="'id'"
				[singleSelectMode]="true"
				(valuesChange)="onaAppScopeProductSelected($event)"
				*ngIf="canSetAppScope"
				[disabled]="viewMode"
			>
			</cv-multiselect-search>
			<div class="product-check-container" *ngIf="productData.appScope.enabled">
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.appScope.invoice"
					[size]="'sm'"
					(valueChange)="toogleInvoiceOptionAppScope($event)"
					[disabled]="viewMode"
				>
				</cv-switch>
				<span>Invoice</span>
			</div>

			<p class="mb-3"></p>
			<cv-dropdown
				[required]="productData.appScope.enabled"
				[label]="'Creation Trigger:(Select when the order must be created)'"
				[selectedValue]="creationTriggerSelected"
				[disabled]="!productData.acuity.enabled || viewMode"
				[options]="creationTriggerList"
				[optionText]="'name'"
				(valuesChange)="onaCreationTriggerSelected($event, 'appScope')"
				*ngIf="canSetNexsys && productData.appScope.enabled"
			>
			</cv-dropdown>
			<p class="mb-3"></p>
			<cv-dropdown
				[label]="'MileStone'"
				[required]="
				productData.appScope.creationTrigger === 'StatusChanged'
				"
				[placeholder]="'Select a MileStone'"
				[selectedValue]="milestoneSelected"
				[disabled]="!productData.appScope.enabled || viewMode"
				[options]="milestoneAcuityList"
				[optionText]="'title'"
				[clearSelection]="!productData.acuity.enabled"
				(valuesChange)="onaMilestoneSelected($event, 'appScope')"
				*ngIf="
				canSetNexsys &&
				productData.acuity.enabled &&
				productData.appScope.enabled &&
				productData.appScope.creationTrigger === 'StatusChanged'
				"
			>
			</cv-dropdown>
			<p class="mb-3"></p>
			<cv-dropdown
				[label]="'Assets on Completion'"
				[placeholder]="'Select an Assets'"
				[selectedValue]="assetsAppscopeSelected"
				[disabled]="!productData.appScope.enabled || viewMode"
				[options]="assetsOnCompletionAppscope"
				[optionText]="'description'"
				[clearSelection]="!productData.appScope.enabled"
				(valuesChange)="onaAssetsonCompletionSelected($event, 'appscope')"
				*ngIf="
				canSetNexsys &&
				productData.appScope.enabled &&
				classValuationIntegration.isEnabled
				"
			>
			</cv-dropdown>
			<div
				class="product-check-container"
				*ngIf="
				canSetNexsys &&
				classValuationIntegration.isEnabled &&
				productData.appScope.enabled
				"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.appScope.disableCommunications"
					[size]="'sm'"
					(valueChange)="disableAppScopeJob($event)"
					[disabled]="viewMode"
				>
				</cv-switch>
				<span> Disable AppScope communication with the provider</span>
			</div>
			<div
				class="product-check-container"
				*ngIf="
				canSetNexsys &&
				classValuationIntegration.isEnabled &&
				productData.appScope.enabled &&
				productData.appScope.creationTrigger === 'StatusChanged'
				"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.appScope.enqueueCommunications"
					[size]="'sm'"
					(valueChange)="enqueueScopeJob($event)"
					[disabled]="viewMode"
				>
				</cv-switch>
				<span>
				Enqueue Provider Event(until the associated provider order is
				received)</span
				>
			</div>
			<div
				class="product-check-container"
				*ngIf="
				canSetNexsys &&
				classValuationIntegration.isEnabled &&
				productData.appScope.enabled
				"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.appScope.borrowerEmailToComments"
					[size]="'sm'"
					(valueChange)="emailToAdditionalComments($event)"
					[disabled]="viewMode"
				>
				</cv-switch>
				<span> Borrower Email to Additional Comments</span>
			</div>
			<cv-dropdown
				[label]="'Associated Product'"
				[placeholder]="classValuationIntegration.placeHolder"
				[selectedValue]="associatedProductSelected"
				[options]="classValuationIntegration.productList"
				[optionText]="'title'"
				[clearSelection]="!productData.appScope.enqueueCommunications"
				(valuesChange)="onAssociatedProductSelected($event)"
				*ngIf="
				productData.appScope.enqueueCommunications &&
				classValuationIntegration.isEnabled
				"
				[disabled]="viewMode"
			>
			</cv-dropdown>
			</fieldset>
			<fieldset class="border-b" *ngIf="canSetAcuity">
			<h6>Acuity Tracker</h6>
			<p class="mb-4 info-test">{{ enableAcuityMsg }}</p>

			<cv-dropdown
				*ngIf="canSetAcuity && productData.acuity.enabled"
				[required]="true"
				[label]="'Acuity Instance'"
				[placeholder]="'Select the acuity origin'"
				[selectedValue]="acuityOriginSelected"
				[options]="acuityTypesOrigin"
				[optionText]="'name'"
				(valuesChange)="onAcuityTypeSelected($event)"
			>
			</cv-dropdown>

			<cv-multiselect-search
				[required]="productData.acuity.enabled"
				[label]="'Product Name'"
				[placeholder]="'Select Acuity product'"
				[disabled]="!productData.acuity.enabled || viewMode || acuityOriginSelected === null || acuityOriginSelected === ''"
				[options]="acuityProductList"
				[values]="acuitySelected"
				[optionText]="'title'"
				[optionValue]="'id'"
				[singleSelectMode]="true"
				(valuesChange)="onAcuityProductSelected($event)"
				*ngIf="canSetAcuity"
			>
			</cv-multiselect-search>
			<p class="mb-3"></p>
			<cv-dropdown
				[label]="'Assets on Completion'"
				[placeholder]="'Select an Assets'"
				[selectedValue]="assetsAcuitySelected"
				[disabled]="!productData.acuity.enabled || viewMode"
				[options]="assetsOnCompletionAcuity"
				[optionText]="'description'"
				[clearSelection]="!productData.acuity.enabled"
				(valuesChange)="onaAssetsonCompletionSelected($event, 'acuity')"
				*ngIf="
				canSetNexsys &&
				productData.acuity.enabled &&
				classValuationIntegration.isEnabled
				"
			>
			</cv-dropdown>
			<div
				class="product-check-container"
				*ngIf="
				canSetNexsys &&
				classValuationIntegration.isEnabled &&
				productData.acuity.enabled
				"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.acuity.disableCommunications"
					[size]="'sm'"
					(valueChange)="disableAcuityJob($event)"
					[disabled]="viewMode"
				>
				</cv-switch>
				<span> Disable Acuity communication with the provider</span>
			</div>
			<div
				class="product-check-container"
				*ngIf="productData.acuity.enabled"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.acuity.bpoProduct"
					[size]="'sm'"
					(valueChange)="activateBPOProdcut($event)"
					[disabled]="viewMode"
				></cv-switch>
				<span>Is BPO product</span>
			</div>
			<cv-dropdown
				[label]="'Add DM link when:'"
				[required]="productData.acuity.bpoProduct"
				[selectedValue]="dmLinkSelected"
				[disabled]="!productData.acuity.bpoProduct || viewMode"
				[options]="milestoneAcuityList"
				[optionText]="'title'"
				[clearSelection]="!productData.acuity.bpoProduct"
				(valuesChange)="onDMLinkSelected($event)"
				*ngIf="productData.acuity.enabled && productData.acuity.bpoProduct"
			>
			</cv-dropdown>
			<div
				class="product-check-container"
				*ngIf="productData.acuity.enabled"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.acuity.is3dProduct"
					[size]="'sm'"
					(valueChange)="activate3DProduct($event)"
					[disabled]="viewMode"
				></cv-switch>
				<span>Is 3D product (If 3D Active, please Enable Inspection below)</span>
			</div>
			<div
				class="product-check-container"
				*ngIf="productData.acuity.enabled"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.inspection.enabled"
					[size]="'sm'"
					(valueChange)="activateInspection($event)"
					[disabled]="viewMode"
				></cv-switch>
				<span
				>Enable Inspection(Creates an Inspection when the acuity order is
				'Accepted by the Vendor')</span
				>
			</div>
			<div
				class="product-check-container ms-5"
				*ngIf="productData.inspection.enabled"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.inspection.injectImagesIntoForm"
					[size]="'sm'"
					(valueChange)="activateBoolField($event, 'inspection.injectImagesIntoForm')"
					[disabled]="viewMode"
				></cv-switch>
				<span>Inject Images into Formset</span>
			</div>
			<div
				class="product-check-container"
				*ngIf="productData.acuity.enabled"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.acuity.invoice"
					[size]="'sm'"
					[disabled]="viewMode"
					(valueChange)="toogleInvoiceOptionAcuity($event)"
				>
				</cv-switch>
				<span>Invoice</span>
			</div>

			<div
				class="product-check-container"
				*ngIf="productData.inspection.enabled"
			>
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="productData.inspection.keepInspection"
					[size]="'sm'"
					(valueChange)="activateKeepInspection($event)"
					[disabled]="viewMode"
				></cv-switch>
				<span
				>Keep Inspection(Avoid create a new inspection each time the order
				is 'Accepted by the Vendor')</span
				>
			</div>
			<cv-dropdown
				[required]="productData.inspection.enabled"
				[label]="'Schema'"
				[placeholder]="'Select a Schema'"
				[selectedValue]="schemaSelected"
				[options]="schemasList"
				[disabled]="!productData.inspection.enabled || viewMode"
				[optionText]="'name'"
				(valuesChange)="onSchemaSelected($event)"
			>
			</cv-dropdown>
			<p class="mb-3"></p>
			<cv-dropdown
				[required]="productData.inspection.enabled"
				[label]="'GSE Preference'"
				[placeholder]="'Select a Preference'"
				[selectedValue]="gsePreferenceSelected"
				[options]="gsePreference"
				[disabled]="!productData.inspection.enabled || viewMode"
				[clearSelection]="!productData.inspection.enabled"
				[optionText]="'name'"
				(valuesChange)="onGSEPreferenceSelected($event)"
			>
			</cv-dropdown>
			<p class="mb-3"></p>

			<div *ngIf="productData.inspection.enabled">
				<div class="product-check-container">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="productData.inspection.gseFungible"
						[size]="'sm'"
						(valueChange)="activateGseFungibility($event)"
						[disabled]="viewMode"
					></cv-switch>
					<span>Enable GSE Fungibility</span>
					<div class="upd-wrapper"
						*ngIf="showUPDInfo" >
						<cv-switch
							[class]="'cv-switch-blue'"
							[checked]="productData.inspection.useUPD"
							[size]="'sm'"
							(valueChange)="activateUseUPD($event)"
							[disabled]="viewMode">
						</cv-switch>
						<span>Use UPD</span>
					</div>
				</div>
				<div class="product-check-container">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="productData.inspection.disableFREDDIESubmition"
						[size]="'sm'"
						(valueChange)="disableGSESubmition($event, 'disableFREDDIESubmition')"
						[disabled]="viewMode"
					>
					</cv-switch>
					<span>Disable FREDDIE Submission </span>

					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="productData.inspection.disableFNMASubmition"
						[size]="'sm'"
						(valueChange)="disableGSESubmition($event, 'disableFNMASubmition')"
						[disabled]="viewMode"
					>
					</cv-switch>
					<span>Disable FNMA Submission </span>
				</div>

			</div>
			<div class="software-collector">
				<cv-dropdown
					*ngIf="productData.inspection.enabled"
					[required]="productData.inspection.enabled"
					[label]="'Software Collector'"
					[placeholder]="'Select a Software Collector'"
					[selectedValue]="productData.inspection.softwareCollector"
					[disabled]="!productData.inspection.enabled || viewMode"
					[options]="softwareCollector"
					[clearSelection]="!productData.inspection.enabled"
					(valuesChange)="onSoftwareCollectorSelected($event)"
				>
				</cv-dropdown>
			</div>

			<div
				*ngIf="showLicensingButton && productData.licensingServiceSetting"
			>
				<div class="col-sm-12 product-check-container">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="enableLicensingService"
						[size]="'sm'"
						(valueChange)="activateLicensing($event)"
						[disabled]="viewMode"
					></cv-switch>
					<span>Enable Licensing Services</span>
				</div>

				<div
					class="col-sm-12 mb-3"
					*ngIf="enableLicensingService"
				>
					<cv-multiselect-search
						[required]="enableLicensingService"
						[label]="'Acuity Product Name'"
						[placeholder]="'Select Acuity Product'"
						[disabled]="!enableLicensingService || viewMode"
						[options]="acuityProductList"
						[values]="acuityLicensingServiceSelected"
						[optionText]="'title'"
						[optionValue]="'id'"
						[singleSelectMode]="true"
						(valuesChange)="onAcuityLicensingProductSelected($event)"
					>
					</cv-multiselect-search>
				</div>

				<div
					class="col-sm-12 mb-3"
					*ngIf="enableLicensingService"
				>
					<cv-dropdown
						[required]="true"
						[label]="'SubProduct Configuration Name'"
						[placeholder]="'Select a product configuration name'"
						(valuesChange)="onAcuityLicensingSubProductSelected($event, 0)"
						[options]="subProductList"
						[optionValue]="'id'"
						[optionText]="'name'"
						[selectedValue]="acuityLicensingSubProduct1"
						[clearSelection]="!enableLicensingService"
						[disabled]="viewMode"
					>
					</cv-dropdown>
				</div>

				<div
					class="col-sm-12 mb-3"
					*ngIf="enableLicensingService"
				>
					<cv-dropdown
						[required]="true"
						[label]="'Creation Trigger'"
						[placeholder]="'Select when the sub-order must be created'"
						[options]="licensingSubProductCreationTriggerList"
						[optionValue]="'id'"
						[optionText]="'name'"
						[selectedValue]="acuityLicensingSubProductCreationTrigger1"
						(valuesChange)="onLicensingSubProductCreationTriggerSelected($event, 0)"
						[disabled]="viewMode"
					>
					</cv-dropdown>
				</div>

				<div
					class="col-sm-12 mb-3"
					*ngIf="enableLicensingService"
				>
					<cv-dropdown
						[required]="true"
						[label]="'SubProduct Configuration Name'"
						[placeholder]="'Select a product configuration name'"
						(valuesChange)="onAcuityLicensingSubProductSelected($event, 1)"
						[options]="subProductList"
						[optionValue]="'id'"
						[optionText]="'name'"
						[selectedValue]="acuityLicensingSubProduct2"
						[clearSelection]="!enableLicensingService"
						[disabled]="viewMode"
					>
					</cv-dropdown>
				</div>

				<div
					class="col-sm-12 mb-3"
					*ngIf="enableLicensingService"
				>
					<cv-dropdown
						[required]="true"
						[label]="'Creation Trigger'"
						[placeholder]="'Select when the sub-order must be created'"
						[options]="licensingSubProductCreationTriggerList"
						[optionValue]="'id'"
						[optionText]="'name'"
						[selectedValue]="acuityLicensingSubProductCreationTrigger2"
						(valuesChange)="onLicensingSubProductCreationTriggerSelected($event, 1)"
						[disabled]="viewMode"
					>
					</cv-dropdown>
				</div>

			</div>

			<div *ngIf="productData.inspection.softwareCollector === 'InsideMaps'">

				<div class="product-check-container">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="productData.insideMaps.enabled"
						[size]="'sm'"
						(valueChange)="activateBoolField($event, 'insideMaps.enabled')"
						[disabled]="viewMode"
					>
					</cv-switch>
					<span>Enable InsideMaps(Creates an IM Project and attach to the
					inspection)</span>
				</div>

				<div *ngIf="productData.insideMaps.enabled">
					<div class="product-check-container">
						<cv-switch
							[class]="'cv-switch-blue'"
							[checked]="productData.insideMaps.sendListingLink"
							[size]="'sm'"
							(valueChange)="activateBoolField($event, 'insideMaps.sendListingLink')"
							[disabled]="viewMode"
						>
						</cv-switch>
						<span>Send Listing Link to Integration?</span>
					</div>

					<div class="product-check-container">
						<cv-switch
							[class]="'cv-switch-blue'"
							[checked]="productData.insideMaps.sendPropertyReportPageLink"
							[size]="'sm'"
							(valueChange)="activateBoolField($event, 'insideMaps.sendPropertyReportPageLink')"
							[disabled]="viewMode"
						>
						</cv-switch>
						<span>Send Property Report Page Link to Integration?</span>
					</div>
				</div>
			</div>

			<div>
				<cv-dropdown
					[required]="productData.insideMaps.enabled"
					[label]="'Software Collector Package'"
					[placeholder]="'Select a Package config...'"
					[selectedValue]="insideMapsSelected"
					[disabled]="viewMode"
					[options]="insideMapsProductList"
					[optionText]="'title'"
					(valuesChange)="onInsideMapsProductSelected($event)"
				></cv-dropdown>

				<div class="my-3">
					<cv-input
						(controlKeyup)="onFeeSetValue($event, 'insideMaps')"
						[value]="productData.insideMaps.insideMapsFee"
						[label]="'Software Collector Fee'"
						[type]="'number'"
						[minlength]="1"
						[min]="0"
						[placeholder]="'Fee Product '"
						[disabled]="viewMode"
					></cv-input>
				</div>
			</div>

			<div
				class="mt-3"
				*ngIf="canSetSideCar && productData.acuity.enabled"
			>
				<h6>SubProduct Configuration</h6>
				<cv-dropdown
					[label]="'Sidecar 1'"
					[placeholder]="'Select a product configuration name'"
					[selectedValue]="sideCar1"
					(valuesChange)="onSideCardConfigProductSelected($event, 1)"
					[options]="subProductList"
					[optionText]="'name'"
					[clearSelection]="!canSetSideCar"
					[disabled]="viewMode"
				>
				</cv-dropdown>
				<cv-input
					(controlKeyup)="onFeeSetValue($event, 'sideCar')"
					[value]="sideCar1.subProductFee"
					[label]="'Sidecar 1 Fee'"
					[type]="'number'"
					[minlength]="1"
					[min]="0"
					[placeholder]="'Fee Sidecar 1 '"
					*ngIf="sideCar1.id"
					[disabled]="viewMode"
				></cv-input>
				<cv-dropdown
					[label]="
						'Creation Trigger:(Select when the order must be created)'
					"
					[selectedValue]="creationTriggerSubProductSelected"
					[options]="creationTriggerList"
					[optionText]="'name'"
					(valuesChange)="onaCreationTriggerSelected($event, 'sideCar')"
					*ngIf="sideCar1.id"
					[disabled]="viewMode"
				>
				</cv-dropdown>

				<div class="product-check-container">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="sideCar1.hybridMode"
						[size]="'sm'"
						(valueChange)="setHybridMode($event, 1)"
						[disabled]="viewMode"
					>
					</cv-switch>
					<span>Hybrid Mode</span>
				</div>

				<p class="mb-3"></p>
				<cv-dropdown
					[label]="'MileStone'"
					[required]="sideCar1.creationTrigger === 'StatusChanged'"
					[placeholder]="'Select a MileStone'"
					[selectedValue]="milestoneSubProductSelected"
					[options]="milestoneAcuityList"
					[optionText]="'title'"
					[clearSelection]="!sideCar1.creationTrigger"
					(valuesChange)="onaMilestoneSelected($event, 'sideCar')"
					*ngIf="
						sideCar1.id && sideCar1.creationTrigger === 'StatusChanged'
					"
					[disabled]="viewMode"
				>
				</cv-dropdown>
				<div class="sidecar-2">
				<cv-dropdown
					[label]="'Sidecar 2'"
					[placeholder]="'Select a product configuration name'"
					[selectedValue]="sideCar2"
					(valuesChange)="onSideCardConfigProductSelected($event, 2)"
					[options]="subProductList"
					[optionText]="'name'"
					[clearSelection]="!canSetAppScope"
					[disabled]="viewMode"
				>
				</cv-dropdown>
				</div>

				<div class="product-check-container">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="sideCar2.hybridMode"
						[size]="'sm'"
						(valueChange)="setHybridMode($event, 2)"
						[disabled]="viewMode"
					>
					</cv-switch>
					<span>Hybrid Mode</span>
				</div>
			</div>
			</fieldset>

			<div>
				<div class="product-check-container mb-4 mt-5" *ngIf="productData.origin === 'AppScope'">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="productData.appScope.enableAcuityFileSincronization"
						[size]="'sm'"
						(valueChange)="productData.appScope.enableAcuityFileSincronization = $event;"
						[disabled]="viewMode"
					></cv-switch>
					<span class="info-test">File synchronization with Acuity</span>
				</div>
				<div class="product-check-container">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="productData.acuity.autoCompleteScopeOrderOption.autoComplete"
						[size]="'sm'"
						(valueChange)="onAutoCompleteScopeOrder($event)"
						[disabled]="viewMode"
					>
					</cv-switch>
					<span>Auto complete appscope order when milestone is:</span>
				</div>

				<cv-multiselect-search
					[label]="'Milestone:'"
					[required]="productData.acuity.autoCompleteScopeOrderOption.autoComplete"
					[values]="autoCompleteMilestoneSelected"
					[disabled]="!productData.acuity.autoCompleteScopeOrderOption.autoComplete || viewMode"
					[options]="milestoneAcuityList"
					[optionText]="'title'"
					(valuesChange)="onAutoCompleteMilestoneSelected($event)"
					*ngIf="productData.acuity.autoCompleteScopeOrderOption.autoComplete"
				>
				</cv-multiselect-search>

				<div class="product-check-container">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="productData.acuity.autoCompleteScopeOrderOption.uploadDocuments"
						[size]="'sm'"
						(valueChange)="onUploadDocumentsScopeOrder($event)"
						[disabled]="viewMode"
					>
					</cv-switch>
					<span>Upload documents inside {{ (productData.origin === 'CMPAcuity' ? 'CMPAcuity (SIDECAR 1)' : productData.origin) || 'Appscope'}} when milestone is:</span>
				</div>

				<cv-multiselect-search
					[label]="'Milestone:'"
					[required]="productData.acuity.autoCompleteScopeOrderOption.uploadDocuments"
					[values]="uploadDocumentsMilestoneSelected"
					[disabled]="!productData.acuity.autoCompleteScopeOrderOption.uploadDocuments || viewMode"
					[options]="milestoneAcuityList"
					[optionText]="'title'"
					(valuesChange)="onUploadDocumentsMilestoneSelected($event)"
					*ngIf="productData.acuity.autoCompleteScopeOrderOption.uploadDocuments"
				>
				</cv-multiselect-search>

				<cv-invision-scope-order-documents
					*ngIf="productData.acuity.autoCompleteScopeOrderOption.uploadDocuments"
					[documents]="productData.acuity.autoCompleteScopeOrderOption.documents"
					[viewMode]="viewMode"
				>
				</cv-invision-scope-order-documents>

				<div class="product-check-container" *ngIf="productData.origin === 'AppScope'">
					<cv-switch
						[class]="'cv-switch-blue'"
						[checked]="productData.acuity.notifyAppscopeAcuityOrderEscalated"
						[size]="'sm'"
						(valueChange)="productData.acuity.notifyAppscopeAcuityOrderEscalated = $event;"
						[disabled]="viewMode"
					>
					</cv-switch>
					<span>Notify Appscope when order gets escalated on codes (104-201)</span>
				</div>
			</div>
		</div>
		<ng-template #emptySelection>
			<div class="empty-selection__content">
			<label class="empty-selection__icon"
				><i class="fas fa-file"></i
			></label>
			<label class="empty-selection__lbl">No Origin Selected</label>
			<label class="empty-selection-instruction__lbl">
				Select an Origin from the list to see integration related to it
			</label>
			</div>
		</ng-template>
		</div>
	</div>
</div>
